import React from 'react'
import Template from '../components/core/Auth/Template'
import loginImg from "../assets/Images/login.webp"

function Login({setIsLoggedIn}) {
  return (
    <Template
    title="Welcome Back"
    description1="Build skills for today, tomorrow, and beyond."
    description2="Education to future-proof your career."
    image={loginImg}
    setIsLoggedIn={setIsLoggedIn}
    />
  )
}

export default Login